import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { broker } from '@axo/shared/data-access/types';
import { email_template_api } from '@axo/shared/data-access/api';
import { communicationTemplateKeys } from '../../cache-keys/communicationTemplateKeys.tsx';
import { queryFunction } from '../../query-function.ts';

export function useEmailTemplates(
  marketCountry: string,
  broker: broker.Broker,
) {
  const api = useAPI();

  const cacheKey = communicationTemplateKeys.emailTemplates({
    marketCountry,
    broker,
  });

  return useQuery(
    cacheKey,
    queryFunction(
      email_template_api.findEmailTemplates(api),
      ({ queryKey: [, market, , broker] }) => ({
        marketCountry: market ?? '',
        broker,
      }),
    ),
    {
      enabled: !!marketCountry,
    },
  );
}
